/**
 * Navigation service. Exposes the sidebar nav tree.
 *
 * Endpoint contract (when backend lands):
 *
 *   GET /navigation                 → { workspace: NavItem[], tools: NavItem[] }
 *
 * Each `NavItem` has `{ key, label, to, icon, count? }`. The
 * `count` field will eventually come from per-domain summary
 * endpoints (or be computed client-side from the stores). For
 * the mock branch we just return the static tree.
 *
 * Returning this through a service — rather than a raw JSON
 * import in Sidebar.vue — means the UI is decoupled from the
 * data source. When permissions / role-based hiding land, the
 * filtering happens here in one place.
 */

import { apiResolve, http, USE_MOCKS } from '@/api'
import navigation from '@/mock/navigation.json'

export default {
  async get() {
    if (USE_MOCKS) return apiResolve(navigation, 40)
    return http.get('/navigation')
  },
}
